module.exports = __webpack_public_path__ + "static/9.1-01d47ebc4ae198f72f5909417490d817.jpg";